module.exports = __webpack_public_path__ + "img/storage.3e7891a8.svg";